export const appDirectorHost = {
  IAT: 'https://iat-adpapps.adp.com/appDirector',
  PROD: 'https://adpapps.adp.com/appDirector'
};

export const webhookUIBaseUrl = {
  DEV: 'https://static.open.dit.adp.com/marketplace-webhookui-mfe',
  DIT: 'https://static.open.dit.adp.com/marketplace-webhookui-mfe',
  IAT: 'https://static.open.iat.adp.com/marketplace-webhookui-mfe',
  PROD: 'https://static.open.adp.com/marketplace-webhookui-mfe'
};

export const webhookAppShellBaseUrl = {
  DEV: 'https://api.local.adp.com/offline',
  DIT: 'https://mkpl-proxy-web.us-east-1.marketplace-apps-dit-nonprod.aws.adp',
  IAT: 'https://marketplace-apps-iat.adp.com',
  PROD: 'https://marketplace-apps.adp.com'
};

export const devPortalBaseByEnv = {
  DEV: 'https://iat-developers.adp.com',
  LOCAL: 'https://iat-developers.adp.com',
  DIT: 'https://dit-developers.adp.com',
  IAT: 'https://iat-developers.adp.com',
  PROD: 'https://developers.adp.com',
};

/** @type {Record<string, {sessionEndpoint: string, sseAskEndpoint: string, feedbackEndpoint: string}>} */
export const assistAgentEndpoints = {
  DEV: {
    sessionEndpoint: "https://local.adp.com/api-central/agent/apps/master-agent/sessions",
    sseAskEndpoint: "https://local.adp.com/api-central/agent/run_sse",
    feedbackEndpoint: "https://local.adp.com/api-central/agent/api/public/user-feedback",
  },
  DIT: {
    sessionEndpoint: "https://marketplace-apps-dit.oneadp.com/apps/integrations/master-agent/create-session",
    sseAskEndpoint: "https://marketplace-apps-dit.oneadp.com/apps/integrations/master-agent/run",
    feedbackEndpoint: "https://marketplace-apps-dit.oneadp.com/apps/integrations/master-agent/api/public/user-feedback",
  },
  IAT: {
    sessionEndpoint: "https://marketplace-apps-iat.adp.com/marketplace/apps/integrations/master-agent/create-session",
    sseAskEndpoint: "https://marketplace-apps-iat.adp.com/marketplace/apps/integrations/master-agent/run",
    feedbackEndpoint: "https://marketplace-apps-iat.adp.com/marketplace/apps/integrations/master-agent/api/public/user-feedback",
  },
  PROD: {
    sessionEndpoint: "https://marketplace-apps.adp.com/marketplace/apps/integrations/master-agent/create-session",
    sseAskEndpoint: "https://marketplace-apps.adp.com/marketplace/apps/integrations/master-agent/run",
    feedbackEndpoint: "https://marketplace-apps.adp.com/marketplace/apps/integrations/master-agent/api/public/user-feedback",
  }
};
